var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c("div", { staticClass: "plan-cards", class: _vm.ui.cardType }, [
        _c("div", { staticClass: "main-information" }, [
          _c("div", { staticClass: "plan-cards--header text-center" }, [
            _c("img", {
              staticClass: "plan-mascots",
              attrs: { src: _vm.ui.mascotsUri, alt: "" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "wrap-definition" }, [
              _c("div", { staticClass: "definition text-center pt-5 px-5" }, [
                _c("h4", { staticClass: "title mt-4" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "subtitle mt-4" }, [
                  _vm._v(_vm._s(_vm.subtitle))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "plan-cards--body px-1 py-4 text-center" }, [
            _c("div", { staticClass: "group-amount-period" }, [
              _vm.amount
                ? _c("h2", { staticClass: "amount m-0" }, [
                    _c("span", { staticClass: "currency" }, [_vm._v("R$")]),
                    _vm._v(_vm._s(_vm.amountReal)),
                    _c("span", { staticClass: "cents" }, [
                      _vm._v("," + _vm._s(_vm.amountCents))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "period text-lowercase" }, [
                      _vm._v(_vm._s(_vm.period))
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrap-subscribe-cta mt-4 mx-auto px-2" }, [
              _c(
                "a",
                {
                  staticClass:
                    "subscribe-cta btn btn-lg btn-block py-3 rounded-pill text-uppercase",
                  attrs: { role: "button" },
                  on: {
                    click: function($event) {
                      return _vm.redirectToCheckout()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.ctaTitle) +
                      "\n                "
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "plan-cards--items" }, [
          _c(
            "ul",
            { staticClass: "items-list text-left p-0 ml-3 mr-3" },
            _vm._l(_vm.itemsList, function(item, index) {
              return _c("li", { key: index, staticClass: "mb-2" }, [
                _c("i", { staticClass: "fas fa-check-circle" }),
                _vm._v(" "),
                _c("span", { staticClass: "ml-2" }, [_vm._v(_vm._s(item))])
              ])
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/template-school/choose-plan-school/PlanSchoolCard.vue?vue&type=template&id=61290dce&
// module id = 447
// module chunks = 1